export const RIGHT_PANEL_OVERLAY_MAX_WIDTH_PX = 639;
export const RIGHT_PANEL_FULLSCREEN_MAX_WIDTH_PX = 639;

export const RIGHT_PANEL_OVERLAY_MEDIA_QUERY = {
  max: RIGHT_PANEL_OVERLAY_MAX_WIDTH_PX + 1,
} as const;

export const RIGHT_PANEL_FULLSCREEN_MEDIA_QUERY = {
  max: RIGHT_PANEL_FULLSCREEN_MAX_WIDTH_PX + 1,
} as const;

export type RightPanelPresentation = "inline" | "overlay" | "fullscreen";

export function shouldUseRightPanelOverlay(viewportWidthPx: number): boolean {
  return viewportWidthPx <= RIGHT_PANEL_OVERLAY_MAX_WIDTH_PX;
}

export function resolveRightPanelPresentation(viewportWidthPx: number): RightPanelPresentation {
  if (viewportWidthPx <= RIGHT_PANEL_FULLSCREEN_MAX_WIDTH_PX) {
    return "fullscreen";
  }
  if (viewportWidthPx <= RIGHT_PANEL_OVERLAY_MAX_WIDTH_PX) {
    return "overlay";
  }
  return "inline";
}

/**
 * The panel's inline width.
 *
 * Maximized means the panel takes the window and the transcript yields, so the
 * width stops being a user-resizable preference and becomes the full column.
 * Returning `null` for the resize config is the point: dragging the edge of a
 * full-width panel has nowhere to go, and leaving the handle live lets a drag
 * silently un-maximize without touching the control that says otherwise.
 */
export function resolveRightPanelInlineWidth(input: {
  readonly maximized: boolean;
  readonly defaultWidth: string;
}): { readonly width: string; readonly resizable: boolean } {
  return input.maximized
    ? { width: "100%", resizable: false }
    : { width: input.defaultWidth, resizable: true };
}
